/**
 * @description: 需要注册到全局的组件
 */
import { App } from 'vue';
import BasePagination from './BasePagination/index.vue';
import BaseTable from './BaseTable/index.vue';
import BaseDialog from './base-dialog/index.vue';
import SvgIcon from './SvgIcon/index.vue';
import OssUpload from './OssUpload/index.vue';
import BaseJsonEditor from './BaseJsonEditor/index.vue';

export default (app: App): void => {
  app.component('BasePagination', BasePagination);
  app.component('BaseTable', BaseTable);
  app.component('BaseDialog', BaseDialog);
  app.component('SvgIcon', SvgIcon);
  app.component('oss-upload', OssUpload);
  app.component('base-json-editor', BaseJsonEditor);
};
